(function () {
    'use strict';

    angular.module('swif.interventions')
        .config(route)
        .factory('swifOpenstcPlanningService', swifOpenstcPlanningService)
        .controller('OpenstcPlanningsController', OpenstcPlanningsController)
        .controller('OpenstcEditPlanningController', OpenstcEditPlanningController);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/plannings/table_view', {
            templateUrl: 'partials/openstc/plannings_table_view.html',
            controller: 'OpenstcPlanningsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', 'swifOpenstcPlanningService', function (route, service) {
                    service.resolveData();
                    return route.check();
                }]
            }
        });
    }

    /**
     * @ngdoc service
     * @name swif.openstc.swifOpenstcPlanningService
     * @description planning manager
     * @requires swif.framework.swifFrameworkService
     **/
    function swifOpenstcPlanningService(swif) {
        'ngInject';
        console.log("init swifOpenstcPlanningService")

        var service = {};
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate('plannings', 'planning', filter);
        };
        service.getCollection = function () {
            return swif.collections.getCollection('plannings');
            
        };
        service.callback = function (error, data) {
            service.getCollection().defaultActionCallback(error, data);
        };

        service.getFullcalendar = function () {
            service.fullcalendar = swif.fullcalendar.getFullcalendar();
            return service.fullcalendar;
        };

        service.preValidate = function (data) {
            if(data.action.id === 'delete') {
                return true
            }

            function preSanitizeTimeSlot (line) {
                return {
                    day_start: line.start.weekday(),
                    range_start: line.start.hour() + line.start.minute() / 60,
                    day_end: line.end.weekday(),
                    range_end: line.end.hour() + line.end.minute() / 60,
                }
            }

            var ret;
            data.model.time_slot_ids = swif.data.prepareOne2manyValues(
                data.model.time_slot_ids,
                data.model.time_slots_events[0],
                preSanitizeTimeSlot
            );
            switch (data.action.id)  {
                case 'add':
                    ret = true;
                    break;
                case 'edit':
                    ret = true;
                    break;
                default:
                    ret = service.getCollection().preValidate(data);
            }
            return ret;
        };

        service.preModal = function (data) {
            return service.getCollection().preModal(data);
        };

        service.resolveData = function () {
            function checkResources() {
                var resources = ['fullcalendar'];
                return swif.route.check({resources: resources});
            }
            return swif.settings.initialize()
                .then(checkResources);
        };

        service.modules = swif.module.modules;
        return service;
    }

    function OpenstcPlanningsController($scope, swifOpenstcPlanningService) {
        'ngInject';
        $scope.modules = swifOpenstcPlanningService.modules;
        swifOpenstcPlanningService.createCollection().then(function (collection) {
            $scope.plannings = collection;
        });
        $scope.callback = swifOpenstcPlanningService.callback;
        $scope.preValidate = swifOpenstcPlanningService.preValidate;
        $scope.preModal = swifOpenstcPlanningService.preModal;

        $scope.getCoveredDays = function (slots) {
            moment.locale('fr');
            const uniqDays = new Set();
            for(const id in slots) {
                var range = Array.from({length:slots[id].day_end - slots[id].day_start + 1},(val,ind)=>ind+slots[id].day_start)
                for (const day in range) {
                    uniqDays.add(range[day]);
                }
            }
            const sortedUniqDays = [...uniqDays].sort()
            const daysValues = []
            for (const id in sortedUniqDays) {
                daysValues.push(moment().weekday(sortedUniqDays[id]).format('dddd'))
            }
            return daysValues.join(', ');
        };
    }

    function OpenstcEditPlanningController($scope, swif, swifOpenstcPlanningService, openstc, $timeout) {
        'ngInject';
        console.log('init OpenstcEditPlanningController')
        $scope.modules = swifOpenstcPlanningService.modules;
        $scope.callback = swifOpenstcPlanningService.callback;
        $scope.preValidate = swifOpenstcPlanningService.preValidate;
        $scope.preModal = swifOpenstcPlanningService.preModal;

        // For new planning
        if (!$scope.model.time_slots) {
            $scope.model.time_slots = [];
        }

        $scope.fullcalendar = swifOpenstcPlanningService.getFullcalendar();
        $scope.fullcalendar.allDaySlot = false;
        $scope.fullcalendar.timezone = swif.user.getTimeZone();
        $scope.fullcalendar.droppable = true;
        $scope.fullcalendar.eventClick = fullcalendarEventClick;
        $scope.fullcalendar.select = fullcalendarSelect;
        $scope.fullcalendar.header.left = "agendaWeek";
        $scope.fullcalendar.header.right = "";
        $scope.fullcalendar.header.center = "";
        $scope.fullcalendar.businessHours = false;
        $scope.fullcalendar.columnFormat = {
			"week" : "dddd",
		},
        $scope.fullcalendar.eventOverlap = false;
        $scope.fullcalendar.weekNumbers = false;
        $scope.fullcalendar.nowIndicator = false;
        $scope.fullcalendar.height = 500;
        $scope.fullcalendar.eventColor = '#888';
        $scope.fullcalendar.selectOverlap = false;
        $scope.fullcalendar.defaultView = 'agendaWeek';
        $scope.fullcalendar.defaultDate = moment().week(-1)
        $scope.model.time_slots_events = [[]];
        loadEvents();

        // Dirty fix to show calendar by default
        $timeout( function(){
            $("#fullcalendar").fullCalendar('render');
        }, 200 );

        // FullCalendar functions
        function loadEvents() {
            for(const ts of $scope.model.time_slots) {
                var event = {
                    id: ts.id,
                    start: moment().week(-1).weekday(ts.day_start).hour(ts.range_start).minute((ts.range_start % 1) * 60).seconds(0).milliseconds(0),
                    end: moment().week(-1).weekday(ts.day_end).hour(ts.range_end).minute((ts.range_end % 1) * 60).seconds(0).milliseconds(0),
                    color: '#82B060',
                    allDay: false,
                    editable: false
        
                }
                $scope.model.time_slots_events[0].push(event);
            }
        }

        function fullcalendarEventClick(event, jsEvent, view) {
            _.remove($scope.model.time_slots_events[0], (n) => {
                return n.start.hour() == event.start.hour() 
                    && n.end.hour() == event.end.hour()
                    && n.start.weekday() == event.start.weekday()
                    && n.end.weekday() == event.end.weekday();
            });
        }

        function fullcalendarSelect (start, end) {
            var event = {
                start,
                end,
                allDay: false,
                color: '#82B060',
                editable: false
            };
            $scope.model.time_slots_events[0].push(event);
        }

    }
})();
